exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".file-upload-wrap[data-v-2dffd4fa]{position:relative}.file-upload-wrap .input-ele[data-v-2dffd4fa]{display:inline-block;width:100%;height:100%;position:absolute;opacity:0}", ""]);
